var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('contact-dialog',{attrs:{"show":(_vm.show),"title":"温馨提醒","confirmText":"购买成人票","cancelText":"修改坐席","content":"学生票仅支持硬座、硬卧、二等座、无座等座席优惠。当前选择了不支持的坐席。请返回修改座席，或购买全价成人票"},on:{"cancel":_vm.cancelContactDialog,"confirm":_vm.confirmContactDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }